import { render, staticRenderFns } from "./a-image.vue?vue&type=template&id=21f34d72&scoped=true"
import script from "./a-image.vue?vue&type=script&lang=js"
export * from "./a-image.vue?vue&type=script&lang=js"
import style0 from "./a-image.vue?vue&type=style&index=0&id=21f34d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f34d72",
  null
  
)

export default component.exports